<template>
    <div class="row mx-0 cart-option-button prz-select" 
         :class="{ 'no-transition' : comboCartMode, 'no-default' : !selected, 'lock-cursor' : disableInput, 'col': !open || optionType == 'qty', 'col-12 expand': expandSelect, 'is-native' : isNative }" 
         @click="open = !open"
    >
        <label v-if="!isNative" :for="elementId" class="label-btn"> {{ label }} </label>
        <i v-if="!isNative" :class="{'open': open}" class="ecom-chevron-down prz-chevron-down"/>
        <div
            v-if="optionType != 'qty' && !isNative"
            class="cart-select"
            :class="{open: open, 'no-sel-active' : !defaultValue && emptySelectionWarning, 'disabled' : disableInput }"
            @blur="open = false"
            :tabindex="itemId"
            :ref="elementId"
            :id="elementId"
        >
            <div class="selected" :class="{'open': open}"> {{ selectedDescription }}</div>
            <ul class="items" :class="{'list-hide': !open}">
                <li
                    v-for="(option, index) of options"
                    :key="option.id"
                    :value="option.id"
                    :data-id="option.id"
                    :data-order="index"
                    :data-isdefaultsku="option.default"
                    class="item"
                    @click="option != selected ? getOptionObj(option) : !open"
                >
                    <p>
                        {{ option.stock ? option.description : option.description + ' - ' + kStrings.kPROD_STOCK_OUT }}
                    </p>
                    <i v-if="selected == option" class="ecom-check prz-checkmark"/>
                </li>
            </ul>
        </div>
        <div v-else-if="isNative" class="simple-select-wrapper native" :class="{'native-open' : open}">
            <span class="select-inner-label" :class="{'no-value' : !selected }"> {{ label }} </span>
            <select :class="{'no-value' : !selected }" 
                    @change="getOptionSelect($event.target.value)"
            >
                <option disabled selected value>
                    {{ label }}
                </option>
                <option v-for="(option, index) in options"
                        :key="option.sku"
                        :value="option.id"
                        :data-id="option.id"
                        :data-order="index"
                        :disabled="!option.stock"
                        :data-isdefaultsku="option.default"
                        v-html="option.description"
                >
                </option>
            </select>
            <i class="arrow-sel ecom-chevron-down prz-chevron-down"/>
        </div>
        <div
            v-else
            class="cart-select"
            :class="{open: open, 'no-sel-active' : !defaultValue && emptySelectionWarning, 'disabled' : disableInput}"
            @blur="open = false"
            :tabindex="tabindex"
            :ref="elementId"
            :name="elementId"
            :id="elementId"
        >
            <div class="selected" :class="{open: open}"> {{ selected }}</div>
            <ul class="items" :class="{'list-hide': !open}">
                <li
                    v-for="n in getNumbers(1, this.qtyLimit)"
                    :key="n"
                    :value="n"
                    @click="setQtyInput(n)"
                    class="item"
                >
                    <p>
                        {{ n }}
                    </p>
                    <i v-if="selected == n" class="ecom-check prz-checkmark"/>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

//import {store} from '@/store/comboCart';

export default {
    name: 'QuickSelectBtn',
    components: {},
    props: {
        label: String,
        options: Array,
        value: Object,
        optionType: String,
        optionsInStock: Array,
        defaultValue: {
            type: Object,
            default: null,
        },
        disableInput: {
            type: Boolean,
            default: false,
        },
        comboCartMode: {
            type: Boolean,
            default: false,
        },
        currentSelection: String,
        itemId: { // for multiple widgets
            type: String,
            default: '0',
        },
        qtyLimit: {
            type: Number,
            default: 1,
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
        isNative: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selected: this.defaultValue ? this.defaultValue : (this.optionType != 'qty' ? null : 1),
            open: false,
        };
    },
    watch: {
        defaultValue: {
            immediate: true,
            handler (value, oldVal) {
               if(!value && this.comboCartMode) {
                   this.selected = null;
               }
            }
        }
    },
    computed: {
        expandSelect() {
            return !this.comboCartMode && this.open && this.optionType != 'qty'
        },
        elementId() {
            return 'select-' + this.optionType + '-' + this.itemId;
        },
        kStrings(){
            return this.$store.getters.kStrings;
        },
        selectedDescription() {
            if (!this.selected) {
                return null;
            }

            return this.selected.stock ? this.selected.description : this.selected.description + ' - ' +
                this.kStrings.kPROD_STOCK_OUT;
        },
    },
    methods: {
        getOptionObj: function(option, single = false) {
            //if (this.optionType != 'qty') {
            this.selected = option;
            this.$emit('input', this.selected);
            if (!single) {
                this.$emit('update-cart-option', this.currentSelection);
            }
        },

        getOptionSelect: function(id) {
            this.selected = this.options.find(elm => elm.id == id);
            this.$emit('input', this.selected);
            this.$emit('update-cart-option', this.currentSelection);
        },

        // for qty selects
        getNumbers: function(start, stop) {
            stop += 1;
            return new Array(stop - start).fill(start).map((n, i) => n + i);
        },

        setQtyInput: function(qty) {
            // this.open = false;
            this.selected = qty;
            this.$emit('empty-selection-warning', false);
            this.$emit('update-cart-qty', qty);
        },
    },
    created() {
        this.$emit('input', this.value);
       /* bus.$on('update-single-select', () => {
            if (this.options && this.optionType != 'qty') {
                this.selected = this.options[0]; // cursed computed vars
                this.getOptionObj(this.options[0], true);
            }
        });

        bus.$on('set-qty-input', (value) => {
            if (this.optionType == 'qty') {
                this.setQtyInput(value);
            }
        });*/
    },
    mounted() {
        if (this.defaultValue) {
            this.$emit('input', this.defaultValue);
        }

        if (this.options && this.options.length == 1) {
            this.getOptionObj(this.options[0], true);
        }

        /* this.$emit('input', this.selected);*/
    },
};
</script>

<style module>

</style>